/**
 * @generated SignedSource<<c2f8c041a1b66c6d3b71b94dbd05973e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadPurposeEnum = "applicant_feedback" | "hiring";
export type CreateChatThreadInput = {
  avatarUrl?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  purpose?: ChatThreadPurposeEnum | null | undefined;
  title?: string | null | undefined;
  userIds: ReadonlyArray<string>;
};
export type ChatThreadEditDialog_CreateMutation$variables = {
  input: CreateChatThreadInput;
};
export type ChatThreadEditDialog_CreateMutation$data = {
  readonly createChatThread: {
    readonly chatThread: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ChatDialogContent_Thread">;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadEditDialog_CreateMutation = {
  response: ChatThreadEditDialog_CreateMutation$data;
  variables: ChatThreadEditDialog_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadEditDialog_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateChatThreadPayload",
        "kind": "LinkedField",
        "name": "createChatThread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatThread",
            "kind": "LinkedField",
            "name": "chatThread",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatDialogContent_Thread"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadEditDialog_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateChatThreadPayload",
        "kind": "LinkedField",
        "name": "createChatThread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatThread",
            "kind": "LinkedField",
            "name": "chatThread",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purpose",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultTitle",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isRecipient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "slug",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timezoneName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "self",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSeenAt",
                        "storageKey": null
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "type": "ChatBot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRoom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableMeetingRoom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "threadType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aaa405c392bc53b93e367175bbb5335a",
    "id": null,
    "metadata": {},
    "name": "ChatThreadEditDialog_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadEditDialog_CreateMutation(\n  $input: CreateChatThreadInput!\n) {\n  createChatThread(input: $input) {\n    chatThread {\n      id\n      ...ChatDialogContent_Thread\n    }\n  }\n}\n\nfragment ChatDialogContent_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadTitle_Recipient\n  ...ChatThreadActions_Recipient\n}\n\nfragment ChatDialogContent_Thread on ChatThread {\n  id\n  purpose\n  ...ChatThreadTitle_Thread\n  ...ChatThreadActions_Thread\n  recipient {\n    __typename\n    ...ChatDialogContent_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadActions_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadEditDialog_Recipient\n}\n\nfragment ChatThreadActions_Thread on ChatThread {\n  id\n  threadType\n  purpose\n  ...ChatThreadEditDialog_Thread\n  recipient {\n    __typename\n    ...ChatThreadActions_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadEditDialog_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n  }\n  ... on ChatBot {\n    id\n    name\n  }\n}\n\nfragment ChatThreadEditDialog_Thread on ChatThread {\n  id\n  title\n  avatarUrl\n  purpose\n  recipient {\n    __typename\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n  }\n}\n\nfragment ChatThreadSettingsButton_Thread on ChatThread {\n  id\n  enableMeetingRoom\n}\n\nfragment ChatThreadSubheader_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    id\n    timezoneName\n  }\n  ... on ChatBot {\n    id\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment ChatThreadTitle_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    name\n    firstName\n    avatarUrl\n    profile {\n      slug\n      id\n    }\n  }\n  ... on ChatBot {\n    avatarUrl\n    name\n  }\n  ...RecipientAvatar_Recipient\n  ...ChatThreadSubheader_Recipient\n}\n\nfragment ChatThreadTitle_Thread on ChatThread {\n  title\n  defaultTitle\n  avatarUrl\n  recipient {\n    __typename\n    ...ChatThreadTitle_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...JoinVideoCallButton_Thread\n  ...ChatThreadSettingsButton_Thread\n}\n\nfragment JoinVideoCallButton_Thread on ChatThread {\n  meetingRoom\n  enableMeetingRoom\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "123a9cb7369dd6434edf8ac36b629fcd";

export default node;
